import Vue from 'vue'
const axios = require('@/utils/axios')
const {baseURL} = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	question_responses : [],
    question_response_mapping : {},

}

const getters = {
	fetchQuestionResponses : (state) => state.question_responses,
	fetchQuestionResponseMappings : (state) => state.question_response_mapping,
}

const actions = {
	clearQuestionResponseMappings({commit}){
		commit("SET_QUESTION_RESPONSES_MAPPING", {})
	},

	loadQuestionResponses({commit}, {token, filter}){
        const query_arr = []
		for(let key in filter){
			if(filter[key]!==null || filter[key]!==undefined){
				query_arr.push(`${key}=${encodeURIComponent(filter[key])}`)	
			}
		}
		const query_str = query_arr.join('&')
		return $http.get(`questionresponse?${query_str}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_QUESTION_RESPONSES', response.data)
		})
	},

    loadQuestionResponseMappings({commit}, {token, filter}){
		const query_arr = []
		for(let key in filter){
			if(filter[key]){
				query_arr.push(`${key}=${encodeURIComponent(filter[key])}`)	
			}
		}
		const query_str = query_arr.join('&')
        return $http.get(`questionresponse/mapping?${query_str}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_QUESTION_RESPONSES_MAPPING', response.data)
		})
	},
	
	updateQuestionResponse({commit}, {question_id, response, token, index}){
		return new Promise((resolve, reject) => {
			$http.put(`/questionresponse/${question_id}`, response, {
				headers : {
					'x-auth-token' : token
				}
			}).then((response) => {
				commit("UPDATE_QUESTION_RESPONSE_MAPPING", {resp : response.data, index, question_id})
				resolve({resp : response.data, index, question_id})
			}).catch(err => {
				reject(err)
			})
		})
		
	},

	removeQuestionResponse({commit}, {question_id, token}){
		return $http.delete(`/questionresponse/${question_id}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then(() => {
			commit("REMOVE_QUESTION_RESPONSE_MAPPING", question_id)
		})
	},

}

const mutations = {
	SET_QUESTION_RESPONSES : (state, responses) => {
		state.question_responses = responses
	},

	SET_QUESTION_RESPONSES_MAPPING : (state, mapping) => {
		state.question_response_mapping = mapping
	},

    UPDATE_QUESTION_RESPONSE_MAPPING : (state, {resp, index, question_id}) => {
        state.question_response_mapping = {
            ...state.question_response_mapping,
            [index] : {
                is_correct : resp.is_correct,
				question : question_id
            }
        } 
    },

	REMOVE_QUESTION_RESPONSE_MAPPING : (state, question_id) => {
		Vue.delete(state.question_response_mapping,question_id) 
    },
}

export default { 
	state, getters, actions, mutations
}